<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { ref, nextTick } from "vue"
import { isMobile } from "@/utils"
import InfoIcon from "@/assets/icons/info.svg?component"

const props = defineProps<{
   text?: string
   html?: string
   icon: { type: boolean; required: false; default: true }
}>()

const dialog = ref(false)
const wrapper = ref<HTMLElement>()
const slot = ref<HTMLElement>()

function showDialogIfMobile() {
   if (isMobile()) {
      dialog.value = true
      nextTick(() => {
         const topMargin = slot.value
            ? slot.value.getBoundingClientRect().y + 32 + "px"
            : "0px"
         if (wrapper.value) {
            wrapper.value.style.top = topMargin
         }
      })
   }
}

function hideDialogIfMobile() {
   if (isMobile()) {
      dialog.value = false
   }
}
</script>

<template>
   <!-- eslint-disable vue/no-v-html -->
   <div class="tooltip--container">
      <div
         id="slot"
         ref="slot"
         class="tooltip--slot"
         @click="showDialogIfMobile"
      >
         <info-icon v-if="props.icon" /><slot class="tooltip--label"></slot>
      </div>
      <div v-if="!isMobile()" :class="['tooltip--bubble']">
         <span v-if="text" :class="['tooltip--text']">{{ props.text }}</span>
         <div v-if="html" :class="['tooltip--text']" v-html="props.html"></div>
      </div>
      <div v-else>
         <div v-if="dialog" class="tooltip--dialog" @click="hideDialogIfMobile">
            <div id="wrapper" ref="wrapper" class="tooltip--wrapper">
               <span v-if="text">{{ props.text }}</span>
               <div v-if="html" v-html="props.html"></div>
            </div>
         </div>
      </div>
   </div>
</template>
